'use strict';

import angular from 'angular';
import { Enum } from '../../enum/index';

export class AlertPopupController {

  /*@ngInject*/
  constructor($mdDialog, title, message) {
    let vm = this;
    vm.$mdDialog = $mdDialog;
    vm.title = (title ? title : 'APPLICATION.ALERT');
    vm.message = message;
  };

  ok() {
    this.$mdDialog.cancel();
  };
}

export default angular.module('ngOskCrmApp.popup.alertPopup', [])
  .controller('alertPopupController', AlertPopupController)
  .name;


// WEBPACK FOOTER //
// ./client/app/shared/popup/alert-popup/alert-popup.controller.js